import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(0, 2),
    marginTop: theme.spacing(2),
  },
  chipSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1),
      gap: theme.spacing(0.5),
    },
  },
  
  chipLabel: {
    fontSize: 14,
    fontWeight: 600,
    whiteSpace: "nowrap",
    marginRight: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
      width: "100%",
    },
  },

  accountChip: {
    padding: "4px 10px",
    borderRadius: 3,
    fontSize: 12,
    fontWeight: 400,
    backgroundColor: "#fbc02d",
    border: "1px solid #e0a800",
    color: "#000",
    cursor: "pointer",
    userSelect: "none",
    transition: "background-color 0.2s, color 0.2s",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#e0a800",
      color: "#fff",
    },
  },
  accountChipActive: {
    backgroundColor: "#e0a800",
    color: "#fff",
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      padding: "3px 8px",
    },
  },

  searchInput: {
    width: "100%",
  },
  searchButton: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(1),
    },
  },
  sectionDivider: {
    backgroundColor: theme.palette.common.black,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      width: "calc(133.33% - 32px)",
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(2),
    },
  },
  chipDivider: {
    backgroundColor: theme.palette.grey[400],
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      width: "calc(133.33% - 32px)",
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(2),
    },
  },
  contentWrapper: {
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    overflow: "visible",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  contentInner: {
    width: "100%",
  },
  paginationWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      paddingRight: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    "& .MuiPagination-ul": {
      justifyContent: "flex-end",
    },
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    border: `1px solid ${theme.palette.grey[400]}`,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    tableLayout: "fixed",
  },
  headerRow: {
    backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : "#e5eaee",
    borderBottom: `1px solid ${theme.palette.type === "dark" ? theme.palette.grey[600] : "#c7cfd6"}`,
  },
  headerCell: {
    fontWeight: 600,
    fontSize: 13,
    padding: theme.spacing(1.5, 2),
    borderRight: `1px solid ${theme.palette.grey[400]}`,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      padding: theme.spacing(1, 0.5),
    },
  },
  bodyRow: {
    height: 48,
    cursor: "pointer",
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    [theme.breakpoints.down("sm")]: {
      height: 40,
    },
  },
  bodyCell: {
    fontSize: 13,
    padding: theme.spacing(1, 2),
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      padding: theme.spacing(0.5, 0.5),
    },
  },
  sendInvitesWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  drawer: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawerPaper: {
    width: "50%",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  clickableRow: {
    cursor: "pointer",
    transition: theme.transitions.create("box-shadow", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeIn,
    }),
  },
  noResults: {
    marginTop: 50,
    textAlign: "center",
    width: "98%",
    "& .no-results-text": {
      border: `1px solid ${"#c62828"}`,
      padding: "8px 92px 8px 92px",
      backgroundColor: "#fff",
      fontSize: "14pt",
      fontStyle: "italic",
      fontWeight: "bold",
      color: "#d32f2f",
      opacity: 0.7,
      borderRadius: 3,
      boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
    },
  },
}));
